import React, { useState } from 'react';
import BottomTabBar from '../components/util/BottomTabBar';
import Header from '../components/util/Header';
import GlobalSearchModal from '../modal/GlobalSearchModal';
import './StorePage.css';

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="container">
      <Header useLogo={true} modalOpen={()=>setIsModalOpen(true)}/>
      <img src="/cokeplay_main.png" style={{width: '100%'}} alt="store_home" />
      <BottomTabBar/>
      {isModalOpen && (
        <>
        <div className="modal-wrapper">
          <GlobalSearchModal onClose={()=>setIsModalOpen(false)}/>
        </div>
      </>)}
    </div>
  );

};

export default Home; 